import * as React from "react";
import Device from "./Device";
import DeviceInfo from "./DeviceInfo";
import { DeviceData } from "../models/DeviceData";
import { Message } from "../models/ProtectiveFunctionWrapper";
import { MasterPoolMismatchItem } from "../models/MasterPoolMismatchItem";
import { ProtectiveFunctionLocation } from "../models/protectiveFunctionLocation";

interface Props {
  zoom: number;
  device: DeviceData;
  handleDeviceClicked: (device: DeviceData, type: string) => void;
  handleDeviceRightClicked: (e: React.MouseEvent, device: DeviceData) => void;
  handleEmptySupportDeviceLocationClick: () => void;
  errorsAndWarnings: Message[];
  supportConfigurationName: string;
  masterPoolMismatchItems?: MasterPoolMismatchItem[];
  handleConfigurationRightClick: (e: React.MouseEvent) => void;
}

export class SupportConfiguration extends React.Component<Props, {}> {
  constructor(props: Props) {
    super(props);
  }

  zoom(value: number, unit: "px" | "em") {
    return `${value * this.props.zoom}${unit}`;
  }

  handleDeviceClicked = () => {
    if (this.props.device) {
      this.props.handleDeviceClicked(this.props.device, "SSS");
    }
  }

  generateSupportImageSrc = (emptySupportErrorsAndWarnings: Message[]) => {
    var src = "/HTMLImages/Elements/SupportConfig.png";

    var hasWarning = false;
    var hasError = false;
    if (emptySupportErrorsAndWarnings.length) {
      hasWarning = emptySupportErrorsAndWarnings.some(x => x.messageType === 'warning');
      hasError = emptySupportErrorsAndWarnings.some(x => x.messageType === 'error');
    }

    if (hasWarning && hasError) {
      src = "/HTMLImages/Elements/SupportConfigWarningError.png";
      return src;
    }

    if (hasWarning) {
      src = "/HTMLImages/Elements/SupportConfigWarning.png";
      return src;
    }

    if (hasError) {
      src = "/HTMLImages/Elements/SupportConfigError.png";
      return src;
    }

    return src;
  }

  render() {
    const handleDeviceRightClicked = this.props.handleDeviceRightClicked;
    const handleDeviceClicked = this.props.handleDeviceClicked;
    const zoom = this.props.zoom;
    const boxSize = this.zoom(50, "px");
    const imgWidth = this.zoom(48, "px");
    const imgHeight = this.zoom(40, "px");
    const deviceX = this.zoom(25, "px");
    const deviceY = this.zoom(13, "px");
    const infoX = this.zoom(4, "px");
    const infoY = this.zoom(-60, "px");

    const fontSize = this.zoom(.9, "em");

    var errorsAndWarnings: Message[] = [];
    var emptySupportErrorsAndWarnings: Message[] = [];
    var emptySupportErrorsAndWarningsText = "";
    if (this.props.device != null) {
      const pt = this.props.device.ptProtectiveFunction;

      if (this.props.errorsAndWarnings) {
        errorsAndWarnings = this.props.errorsAndWarnings.filter(x => x.messageItems ? x.messageItems.some(c => c.id === pt.protectiveFunctionID) : false);
      }
    } else {
      if (this.props.errorsAndWarnings) {
        emptySupportErrorsAndWarnings = this.props.errorsAndWarnings.filter(x => x.messageItems ? x.messageItems.some(c => c.id == this.props.supportConfigurationName) : false);

        if (emptySupportErrorsAndWarnings) {
          emptySupportErrorsAndWarningsText = emptySupportErrorsAndWarnings.map(x => x.formatMessageById(this.props.supportConfigurationName)).join('\n');
        }
      }
    }

    return (
      <div title={emptySupportErrorsAndWarningsText} className="supportDiv" onClick={() => this.handleDeviceClicked} onContextMenu={(e: React.MouseEvent) => this.props.handleDeviceRightClicked(e, this.props.device)}>
        {this.props.device != null ?
          <div>
            <DeviceInfo x={infoX} y={infoY} fontSize={fontSize} device={this.props.device} />
            <Device masterPoolMismatchItems={this.props.masterPoolMismatchItems} type={"SSS"} x={deviceX} y={deviceY} boxSize={boxSize} imgWidth={imgWidth} imgHeight={imgHeight} errorsAndWarnings={errorsAndWarnings} device={this.props.device} handleDeviceClicked={handleDeviceClicked} handleDeviceRightClicked={handleDeviceRightClicked} />
          </div>
          :
          <div
            id="supportBox"
            style={{
              zIndex: 10000, position: "absolute", top: deviceY, left: deviceX, height: boxSize, width: boxSize, backgroundColor: "rgb(255,0,0,0)",
              pointerEvents: "all"
            }}
            onClick={() => this.props.handleEmptySupportDeviceLocationClick()}
            onContextMenu={this.props.handleConfigurationRightClick}
          ></div>
        }

        {/* Background */}
        <img style={{ width: `${100 * zoom}px`, height: `${100 * zoom}px` }} src={this.generateSupportImageSrc(emptySupportErrorsAndWarnings)} />
      </div>
    );
  }
}